export default __webpack_public_path__ + "static/media/Slide26.15f65ff4.JPG";